import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { Repository } from '../../../services/repository'



@Component({
    selector: 'article-approvers-avatar',
  template: `
        <span *ngFor='let approver of approvers; let i = index'> \
        <img alt="image" title="{{ approver.FullName }}/{{ approver.ChucVu }}" class="img-circle" [src]="approver.AvatarUrl"> \
        <i class="fa fa-arrow-right"></i>
        </span>
  `,
  providers: [Repository]
  })
export class ArticleApproversAvatarDirective implements  OnInit {

    
  renderValue: string;

  @Input() articleid: string | number;
  @Input() userid: string | number;
  @Output() completeEvent: EventEmitter<any> = new EventEmitter();

  approvers: any = [];

  status: any = null;
  statusText: any = null;
  
  constructor(private repo: Repository) {

   
  }
  ngOnInit() {
    this.repo.getRequest("api/nguoidung/getarticleapprovers/" + this.articleid)
      .subscribe(response => {
        this.approvers = response;

        var keepGoing = true;
        var denm = 0;
        response.forEach(
          (item) => {

            if (keepGoing && item.TrangThaiDuyet != 'Đã duyệt' && item.TrangThaiDuyet != 'Hoàn thành') {
              keepGoing = false;
              this.status = 'Continue'
              this.statusText = 'Đang duyệt'
            }

            if (item.NguoiTao2 == this.userid)
              denm = 1;
          })
        if (keepGoing) {
          this.status = 'Completed'
          this.statusText = 'Hoàn thành'
        }

        if (response.length == 1)
          this.completeEvent.emit({ soduyet: 0, status: this.status, statusText: this.statusText, duyet: denm });
        else
          this.completeEvent.emit({ soduyet: 1, status: this.status, statusText: this.statusText, duyet: denm });
      });
  }


}
